// 想用 axios 则必须先把 axios 引入
// import axios from 'axios';
export function disRemoveSentFileUrl({ commit },option) {
    commit('removeSentFileUrl') // 删除
  }

  export function removeUpdateUser({ commit },option) {
    commit('setUpdateUser',option) // 团队管理修改完清空数据
  }

  export function setMemoryBankList({ commit },option) {
    commit('setMemory',option) // 
  }